<template>
    <div class="tsbx">
        <div class="tsbxc">
            <div class="gritem" @click="go('/wyfw/wyjj')">
                <div class="gileft">
                    <img src="../../assets/icon/wyjj.png" alt="" width="30">
                    <span>小区概况</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go('/wyqy')">
                <div class="gileft">
                    <img src="../../assets/icon/wyqy.png" alt="" width="30">
                    <span>物业企业</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go('/wyfw/wyjj/fwht')">
                <div class="gileft">
                    <img src="../../assets/icon/fwht.png" alt="" width="30">
                    <span>服务合同</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <div class="gritem" @click="go('/wyfw/wyjj/sfxx')">
                <div class="gileft">
                    <img src="../../assets/icon/sfbz.png" alt="" width="30">
                    <span>收费标准</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div>
            <!-- <div class="gritem" @click="go('/tsbx/tslx')">
                <div class="gileft">
                    <img src="../../assets/newicon/tsdh.png" alt="" width="30">
                    <span>投诉电话</span>
                </div>
                <div class="giright">
                    <img src="../../assets/tsbx/you.png" alt="">
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        go(path){
            this.$router.push({ path: path });
        }
    },
}
</script>
<style lang="less" scoped>
    .tsbx{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .tsbxc{
            width: calc(100% - 6%);
            .gritem{
                margin-top: 15px;
                height: 60px;
                width: 100%;
                display: flex;
                background: #fff;
                align-items: center;
                border-radius: 10px;
                justify-content: space-between;
                .gileft{
                    display: flex;
                    height: 100%;
                    align-items: center;
                    width: 70%;
                    img{
                        margin-left: 20px;
                    }
                    span{
                        margin-left: 10px;
                    }
                }
                .giright{
                    margin-right: 20px;
                    height: 100%;
                    align-items: center;
                    display: flex;
                    flex-direction:row-reverse;
                    img{
						display: block;
						height: 18px;
					}
                }
            }
        }
    }
</style>
